/* eslint-disable indent */
import React from 'react'
import { Card } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faUser,
  faDiceThree,
  faBoltLightning,
  faGear,
  faWind,
} from '@fortawesome/free-solid-svg-icons'
import { agreeaArray, skillArrayB, specArray } from '../services/arrays'
import { getTranslation } from '../services/translations'
import { calculateEstimatedForm } from '../services/helpfunctions'

const agreeabilityColors = [
  '#e74c3c',
  '#e67e22',
  '#f1c40f',
  '#8ecc39',
  '#2ecc71',
  '#39ff14',
]
const specIcons = {
  1: faGear,
  2: faWind,
  3: faBoltLightning,
  4: faDiceThree,
  5: faUser,
}

const getValueColor = (value, min, max) => {
  const colors = [
    '#e74c3c',
    '#e67e22',
    '#f1c40f',
    '#8ecc39',
    '#2ecc71',
    '#39ff14',
  ]
  const clamped = Math.min(max, Math.max(min, Number(value)))
  const ratio = max === min ? 1 : (clamped - min) / (max - min)
  const index = Math.round(ratio * (colors.length - 1))
  return colors[index]
}

const PlayerInfoCard = ({ player, playerSkills, lang }) => {
  const t = key => getTranslation(lang, key)
  const skillArray = [...skillArrayB].reverse()
  const specNum = Number(player.specialty)
  const currentPlayerSkills = playerSkills || player.playerSkills || {}
  const estimatedForm = calculateEstimatedForm(player, currentPlayerSkills)

  return (
    <Card
      className="w-100"
      style={{
        backgroundColor: '#23272A',
        color: '#FFFFFF',
        borderColor: '#1E2124',
        fontSize: '0.85rem',
      }}
    >
      <Card.Header
        style={{
          backgroundColor: '#1a1d21',
          color: '#FFFFFF',
          fontSize: '0.8rem',
          padding: '6px 12px',
        }}
      >
        {t('generalInfo')}
      </Card.Header>
      <Card.Body style={{ padding: '8px 12px' }}>
        <div>
          {t('character')}: {agreeaArray[Number(player.agreeability) + 1]}{' '}
          <span
            style={{
              color: agreeabilityColors[Number(player.agreeability)] || '#fff',
              fontSize: '0.7rem',
            }}
          >
            ({Number(player.agreeability)})
          </span>
        </div>
        <div>
          {t('experience')}: {skillArray[Number(player.experience)]}{' '}
          <span
            style={{
              color: getValueColor(player.experience, 0, 20),
              fontSize: '0.7rem',
            }}
          >
            ({Number(player.experience)})
          </span>
        </div>
        <div>
          {t('leadership')}: {skillArray[Number(player.leadership)]}{' '}
          <span
            style={{
              color: getValueColor(player.leadership, 1, 7),
              fontSize: '0.7rem',
            }}
          >
            ({Number(player.leadership)})
          </span>
        </div>
        <div>
          {t('loyalty')}: {skillArray[Number(player.loyalty)]}{' '}
          <span
            style={{
              color: getValueColor(player.loyalty, 1, 20),
              fontSize: '0.7rem',
            }}
          >
            ({Number(player.loyalty)})
          </span>
        </div>
        <div>TSI: {player.tsi}</div>
        <div>
          {t('salary')}: {player.salary / 10} €
        </div>
        <div>
          {t('specialty')}:{' '}
          {specIcons[specNum] ? (
            <>
              <FontAwesomeIcon
                icon={specIcons[specNum]}
                style={{ marginRight: '4px' }}
              />
              {specArray[specNum]}
            </>
          ) : (
            specArray[specNum]
          )}
        </div>
        <div>
          {t('form')}: {player.playerForm}
          {estimatedForm !== null && (
            <> | {t('estimatedForm')}: {estimatedForm.toFixed(2)}</>
          )}
        </div>
        <div>
          {t('stamina')}: {Number(currentPlayerSkills.staminaSkill).toFixed(2)}
        </div>
        <div>
          HTMS: {player.HTMS[0]}/{player.HTMS[1]}
        </div>
      </Card.Body>
    </Card>
  )
}

export default PlayerInfoCard
